const CUSTOM_LOGO = process.env.REACT_APP_LOGO;
const CUSTOM_NAME = process.env.REACT_APP_BRAND_NAME;
const CUSTOM_COMPANY_NAME = process.env.REACT_APP_COMPANY_NAME;
const ONU_LOGO = CUSTOM_LOGO || "/img/onu.png";

const BRANDS = {
    fast: {
        key: "fast",
        tier: "primary",
        name: CUSTOM_NAME || "빠른결제대행사",
        companyName: CUSTOM_COMPANY_NAME || "주식회사 빠른",
        hostnames: ["admin.payblue.t4t4.kr", "localhost"],
        logo: CUSTOM_LOGO || "/img/dl_logo_white.png",
        logoSymbol: CUSTOM_LOGO || "/img/dl_symbol.png",
        loginLogo: CUSTOM_LOGO || "/img/dl_logo_white.png",
        excelPrefix: "admin",
        topAgentId: "fast00160",
    },
    jpay: {
        key: "jpay",
        tier: "primary",
        name: "제이페이먼츠",
        companyName: "주식회사 제이페이먼츠",   // TODO: 확인
        hostnames: [],                         // TODO: 실제 도메인
        logo: "",                              // TODO: 로고 파일
        logoSymbol: "",                         // TODO: 심볼 파일 (없으면 logo 사용)
        loginLogo: "",                          // TODO: 로그인 로고
        excelPrefix: "jpay",
        topAgentId: "",                         // TODO: 최상위 에이전트 ID
    },
    baekma: {
        key: "baekma",
        tier: "primary",
        name: "백마나무",
        companyName: "주식회사 백마나무",        // TODO: 확인
        hostnames: ["admin.inbiz.ntpay.kr"],
        logo: "/img/wh_logo_white.png",
        logoSymbol: "/img/wh_logo_white.png",
        loginLogo: "/img/wh_logo_white.png",
        excelPrefix: "baekma",
        topAgentId: "",                         // TODO: 최상위 에이전트 ID
    },
    onu: {
        key: "onu",
        tier: "sub",
        name: CUSTOM_NAME || "오앤유",
        companyName: CUSTOM_COMPANY_NAME || "오앤유",
        hostnames: ["admin.onu-terminal.com"],
        logo: ONU_LOGO,
        logoSymbol: ONU_LOGO,
        loginLogo: ONU_LOGO,
        excelPrefix: "onu",
        topAgentId: "",                         // TODO: 최상위 에이전트 ID (있다면)
    },
};

/** 브랜드 결정: env 우선 → hostname 매칭 → fast 기본값 */
export function getBrand() {
    const envBrand = process.env.REACT_APP_HOST_BRAND;
    const brandAliases = { "onu-t": "onu", "onu-s": "onu" };
    const resolvedBrand = brandAliases[envBrand] || envBrand;
    if (resolvedBrand && BRANDS[resolvedBrand]) return BRANDS[resolvedBrand];

    const host = typeof window !== 'undefined'
        ? window.location.hostname
        : '';
    const found = Object.values(BRANDS).find(b => b.hostnames.includes(host));
    if (found) return found;

    return BRANDS.fast;
}

/** tier 기반 기능 판별 헬퍼 */
export function isPrimary() {
    return getBrand().tier === "primary";
}

export default BRANDS;
